<div class="page-header">
  <div class="page-header-title">
    {{ (tournament ? 'title.tournament-edit' : 'title.tournament-new') | translate }}
  </div>
</div>
<!-- tournament form -->
@if(formTournament) {
  <form class="tournament-form gigantix-form flex gap-2 flex-col" [formGroup]="formTournament">
    <!-- name -->
    <input type="text" [formControl]="fT['name']" class="gigantix-input w-full"
      [placeholder]="'field.name' | translate" pInputText />
    <div class="flex gap-2 flex-row">
      <!-- town -->
      <input type="text" [formControl]="fT['town']" class="gigantix-input w-full"
        [placeholder]="'field.town' | translate" pInputText />
      <!-- province -->
      <input type="text" [formControl]="fT['province']" class="gigantix-input w-full"
        [placeholder]="'field.province' | translate" pInputText />
    </div>
    <div class="flex gap-2 flex-row">
      <!-- startDate -->
      <p-datepicker [formControl]="fT['startDate']" class="gigantix-datepicker w-full"
        [placeholder]="'field.startDate' | translate" [firstDayOfWeek]="1" />
      <!-- endDate -->
      <p-datepicker [formControl]="fT['endDate']" class="gigantix-datepicker w-full"
        [placeholder]="'field.endDate' | translate" [firstDayOfWeek]="1" />
    </div>
    <div class="flex gap-2 flex-row">
      <!-- division -->
      <p-select formControlName="division" [options]="divisionOptions"
        optionLabel="name" [placeholder]="'field.division' | translate" class="gigantix-select w-full" />
      <!-- maxTeams -->
      <p-select formControlName="maxTeams" [options]="maxTeamsOptions"
        optionLabel="name" [placeholder]="'field.maxTeams' | translate" class="gigantix-select w-full"
        [disabled]="!!tournament?.id && tournament?.stage !== 'DRAFT'" />
      <!-- hasConsolation -->
      <p-togglebutton name="hasConsolation" formControlName="hasConsolation" 
        [onLabel]="('field.hasConsolation' | translate) + ': ' + ('yes' | translate)" 
        [offLabel]="('field.hasConsolation' | translate) + ': ' + ('no' | translate)"
        [disabled]="!!tournament?.id && !_.includes(['DRAFT', 'GROUPS', 'ROUNDS'], tournament?.stage)" 
        class="min-w-40" />
    </div>
  </form>
  <div class="footer-buttons">
    <p-button [label]="'button.cancel' | translate" styleClass="gigantix-button button-cancel" (click)="cancel()"></p-button>
    <p-button [label]="'button.save' | translate" styleClass="gigantix-button button-confirm" (click)="save()"></p-button>
  </div>
}